



















import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({})
export default class Navigation extends Vue {
  @Prop({ type: Number, default: 1}) public page!: number;
  @Prop({ type: Number, default: 1}) public total!: number;
}
